export default function Hero() {
  return (
    <section className="bg-white pt-20 pb-10 text-center">
      <div className="container mx-auto px-4 max-w-[70%]">
        <h1 className="mb-4 text-4xl font-bold text-gray-900 sm:text-5xl md:text-6xl">
          Simple, Transparent Pricing
        </h1>
        <p className="mx-auto max-w-2xl text-xl text-gray-600">
          Choose the plan that best fits your influencer marketing needs. Scale
          up or down as your requirements change.
        </p>
      </div>
    </section>
  );
}
